<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
    />
    <path d="M9.1 9a3 3 0 1 1 5.8 1c0 2-3 2-3 4" />
    <path d="M12 17h.01" />
  </svg>
</template>

<script>
export default {
  name: 'IconCircleQuestion',
  props: {
    size: { type: [String, Number], default: 24 },
    strokeWidth: { type: [String, Number], default: 2.2 },
  },
};
</script>
